import pino from 'pino';

// Configure pino for browser environment
const logger = pino({
  level: import.meta.env.PROD ? 'info' : 'debug',
  browser: {
    asObject: true,
    serialize: true,
    transmit: {
      level: 'error',
      send: (level, logEvent) => {
        // In production, you could send errors to a logging service here
        if (level === 'error' || level === 'fatal') {
          console.error('Logger event:', logEvent);
        }
      }
    }
  },
  // Use pino-pretty formatting in development
  ...(import.meta.env.DEV && {
    transport: {
      target: 'pino-pretty',
      options: {
        colorize: true,
        translateTime: 'SYS:HH:MM:ss',
        ignore: 'pid,hostname'
      }
    }
  })
});

// Create child loggers for different modules
export const createLogger = (module: string) => {
  return logger.child({ module });
};

// Export default logger
export default logger;

// Convenience exports for common modules
export const appLogger = createLogger('App');
export const firebaseLogger = createLogger('Firebase');
export const storageLogger = createLogger('Storage');
export const errorLogger = createLogger('ErrorHandler');
export const componentLogger = createLogger('Component');
